<div class="additional-fields-card">

  <div class="doc-insidecard">

    <!-- HEADER -->
    <div class="top-header">
      <div class="header-left">
        <wm-common-text
          class="head-title"
          [data]="{ text: 'Additional Fields' }">
        </wm-common-text>
      </div>

      <button mat-icon-button (click)="isOpen = !isOpen">
        <mat-icon>
          {{ isOpen ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </button>
    </div>

    <!-- CONTENT -->
    <div *ngIf="isOpen">

      <!-- 🔴 NO DATA STATE -->
      <div *ngIf="!fields?.length" class="additional-fields-no-data">
        <wm-common-text
          class="no-data-text"
          [data]="{ text: 'No Data Found' }">
        </wm-common-text>
      </div>

      <!-- 🟢 DATA GRID -->
      <div class="fields-grid" *ngIf="fields?.length">

        <div class="field-item" *ngFor="let field of fields">

          <!-- Added by Amisha on 2026-06-29.
               Reason: Long additional-field labels should truncate inside each grid cell
               and still expose the full text on hover. -->
          <div class="field-text-wrap" [attr.title]="field.label || ''">
            <wm-common-text
              class="field-label"
              [data]="{ text: field.label }">
            </wm-common-text>
          </div>

          <!-- Added by Amisha on 2026-06-29.
               Reason: Additional-field values can be lengthy, so Janus should show
               ellipsis in-grid and the full resolved value in the hover tooltip. -->
          <div class="field-text-wrap" [attr.title]="getDisplayValue(field)">
            <wm-common-text
              class="field-value"
              [data]="{ text: getDisplayValue(field) }">
            </wm-common-text>
          </div>

        </div>

      </div>

    </div>

  </div>

</div>
